<script>
import moment from 'moment'
import {
  rexRoundedMultiSelect,
  rexRoundedDate,
  rexRoundedText,
  rexRoundedCheckbox
} from '@/components/views/rexRoundedField'
import {
  rexDropdown
} from '@/components/views/rexField'

export default {
  name: 'form-filters',
  components: {
    rexRoundedDate,
    rexRoundedMultiSelect,
    rexRoundedText,
    rexDropdown,
    rexRoundedCheckbox
  },
  data: () => ({
    timer: null,
    dateTypes: [
      {
        slug: 'startDate',
        name: 'Заезда'
      },
      {
        slug: 'createDate',
        name: 'Создания'
      }
    ],
    types: [
      {
        name: 'ФИТ',
        slug: 'fit',
      },
    ],
    statuses: [
      {
        name: 'Подтвержден',
        slug: 'confirmed',
      },
      {
        name: 'Аннулирован',
        slug: 1,
      },
      {
        name: 'Аннулирован со штрафом',
        slug: 2,
      },
    ],
    payments: [
      {
        name: 'Не оплачен',
        slug: 0
      },
      {
        name: 'Частично оплачен',
        slug: 1
      },
    ]
  }),
  computed: {
    minPossibleDate() {
      // Возвращает дату, равную 1 секунде до 1 января 2017 года
      // Необходима для установки предельного минимального значения в датапикерах
      return moment(1483221599000).toDate()
    },
    minDateTo() {
      return moment(this.form.dateTo, 'DD.MM.YYYY').toDate()
    },
    onlyUpdates: {
      get() {
        return this.$store.getters['orders/getField']('form.onlyUpdates')
      },
      set(value) {
        this.$store.commit('orders/setField', {
          target: 'form.onlyUpdates',
          value,
        })
      }
    },
    form() {
      return this.$store.getters['orders/getForm']
    }
  },
  methods: {
    dateTypesLabelFormatter: label => `Даты ${label} от/до`,
    inputHandler() {
      clearTimeout(this.timer)
      if (this.form.filters.searchValue.length > 2) {
        this.timer = setTimeout(() => {
          this.search()
        }, 2000)
      }
    },
    search() {
      this.$store.commit('orders/setIsLoading', true)
      this.$store.commit('orders/setCollection', [])

      this.$store.dispatch('orders/getCollection', {
        ...this.form,
        page: 1,
      })
    },
  }
}
</script>
<template>
  <div class="orders__form-filters">
    <b-field
      class="rex-field rex-field__input"
      label="Поиск"
    >
      <rex-rounded-text
        store-module="orders"
        getter-name="getField"
        setter-name="setField"
        target="form.searchValue"
        css-class="orders__form-filters-input"
        :data="form.searchValue"
        :show-label="false"
        @onChange="inputHandler"
      />
    </b-field>
    <div class="orders__form-filters-selector">
      <rex-dropdown
        name="ordersDatesType"
        store-module="orders"
        getter-name="getField"
        setter-name="setField"
        target="form.filterDate"
        :data="dateTypes"
        :custom-label="true"
        :label-formatter="dateTypesLabelFormatter"
        @onChange="search"
      />
    </div>
    <b-field
      class="rex-field rex-field__datepicker"
    >
      <rex-rounded-date
        store-module="orders"
        getter-name="getField"
        setter-name="setField"
        target="form"
        range-start-date-name="dateFrom"
        range-end-date-name="dateTo"
        position="is-bottom-left"
        :is-range-picker="true"
        :range="true"
        :years-range="[-10, 10]"
        :min-date="minPossibleDate"
        @onChange="search"
      />
    </b-field>
    <b-field
      label="Тип"
      class="rex-field rex-field__select"
    >
      <rex-rounded-multi-select
        store-module="orders"
        getter-name="getField"
        setter-name="setField"
        target="form.types"
        :css-absolute="true"
        :data="types"
        :show-label="false"
        empty-text="Все"
        @onChange="search"
      />
    </b-field>

    <b-field
      label="Статус"
      class="rex-field rex-field__select"
    >
      <rex-rounded-multi-select
        store-module="orders"
        getter-name="getField"
        setter-name="setField"
        target="form.statuses"
        :css-absolute="true"
        :data="statuses"
        :show-label="false"
        empty-text="Все"
        @onChange="search"
      />
    </b-field>

    <b-field
      label="Оплата"
      class="rex-field rex-field__select"
    >
      <rex-rounded-multi-select
        store-module="orders"
        getter-name="getField"
        setter-name="setField"
        target="form.payments"
        :css-absolute="true"
        :data="payments"
        :show-label="false"
        empty-text="Все"
        @onChange="search"
      />
    </b-field>
    <rex-rounded-checkbox
      store-module="orders"
      getter-name="getField"
      setter-name="setField"
      target="form.onlyUpdates"
      css-class="orders__form-filters-item-checkbox"
      text="Только с обновлениями"
      :show-label="false"
      :use-custom-values="true"
      :custom-true="1"
      :custom-false="0"
      @onChange="search"
    />
  </div>
</template>
